export const commonPageStylesIdentifier = 'g-CommonPageStyes';
